import { render, staticRenderFns } from "./PrimaryTag.vue?vue&type=template&id=0f78886b&scoped=true"
import script from "./PrimaryTag.vue?vue&type=script&lang=js"
export * from "./PrimaryTag.vue?vue&type=script&lang=js"
import style0 from "./PrimaryTag.vue?vue&type=style&index=0&id=0f78886b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78886b",
  null
  
)

export default component.exports